import InitialState from "./initialState";

export default function SetUpDetailsMainReducer(
  state = InitialState.setUpDetails,
  action: any
) {
  switch (action.type) {
    case "[SETUP_DETAILS] SET_DESIGNATION_ID":
      return { ...state, desgination_id: action.payload };
    default:
      return state;
  }
}
